/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const fullscreen_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m.75 23.25 8-8m-8 3v5h5m9.5-14.5 8-8m-5 0h5v5M.75.75l8 8m-3-8h-5v5m14.5 9.5 8 8m0-5v5h-5"
    />
  </svg>
)
export default fullscreen_medium
